import { render } from "./DiscreteValues.vue?vue&type=template&id=bcb092b0"
import script from "./DiscreteValues.vue?vue&type=script&lang=ts"
export * from "./DiscreteValues.vue?vue&type=script&lang=ts"
script.render = render

export default script